import UNITEDAIRLINES from '../../images/homepage/unitedAirlines.png';
import EMIRATES from '../../images/homepage/emiratesAirlines.png';
import DELTA from '../../images/homepage/deltaAirlines.png';
import TURKISHAIRLINES from '../../images/homepage/turkishAirlines.png';
import KLM from '../../images/homepage/klm.png';
import ALASKA from '../../images/homepage/alaskaAirlines.png';
import SOUTHWESTAIRLINES from '../../images/homepage/southwestAirlines.png';
import AIRFRANCE from '../../images/homepage/airFrance.png';
import ETIHAD from '../../images/homepage/etihadAirlines.png';

const CompanyCards = () => {
    const companies = [
      { logo: UNITEDAIRLINES, position: 'Flight Attendant', company: 'United Airlines' },
      { logo: EMIRATES, position: 'Cabin Crew', company: 'Emirates' },
      { logo: DELTA, position: 'Flight Attendant', company: 'Delta Airlines' },
      { logo: TURKISHAIRLINES, position: 'Cabin Crew', company: 'Turkish Airlines' },
      { logo: KLM, position: 'Cabin Crew', company: 'KLM' },
      { logo: ALASKA, position: 'Flight Attendant', company: 'Alaska Airlines' },
      { logo: AIRFRANCE, position: 'Flight Attendant', company: 'Air France' },
      { logo: SOUTHWESTAIRLINES, position: 'Flight Attendant', company: 'Southwest Airlines' },
      { logo: ETIHAD, position: 'Cabin Crew', company: 'Etihad Airways' },
    ];
  
    return (
      <div className="company-card-grid">
        {companies.map((company, index) => (
          <div className="company-card" key={index}>
            <div className="card-top">
              <img src={company.logo} alt={`${company.company} Logo`} className="company-logo" />
            </div>
            <div className="card-content">
              <h3>{company.position}</h3>
              <a href="/login">
                <button className="card-button">Start Interview</button>
              </a>
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default CompanyCards;